import React, { useState } from 'react';
import '../../scss/components/GiftsPage/GiftAdmin.scss';
import axiosInstance from '../../utils/axiosConfig';
import GiftTopSvg from '../../assets/gift-top.svg';

const GiftAdmin = ({ gifts, setGifts }) => {
    const [giftsList, setGiftsList] = useState(gifts || []);
    const [isSaving, setIsSaving] = useState(false);

    const addGift = () => {
        setGiftsList([...giftsList, { name: '', description: '' }]);
    };

    const removeGift = (index) => {
        const updatedGifts = [...giftsList];
        updatedGifts.splice(index, 1);
        setGiftsList(updatedGifts);
    };

    const handleGiftChange = (index, field, value) => {
        const updatedGifts = [...giftsList];
        updatedGifts[index][field] = value;
        setGiftsList(updatedGifts);
    };

    const saveGifts = async () => {
        setIsSaving(true);
        try {
            // Удаляем пустые подарки
            const validGifts = giftsList.filter(gift => gift.name.trim() !== '' && gift.description.trim() !== '');

            if (validGifts.length === 0) {
                setIsSaving(false);
                return;
            }

            const { data: result } = await axiosInstance.post('/gifts/save', {
                data: validGifts
            });

            if (result.success) {
                setGifts(validGifts);
            } else {
                throw new Error(result.error || 'Ошибка сохранения');
            }
        } catch (error) {
            console.error('Ошибка при сохранении подарков:', error);
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="gift-admin-container">
            <h2 className="admin-title">Управление подарками</h2>

            <div className="gift-items-list">
                {giftsList.map((gift, index) => (
                    <div key={index} className="gift-edit-item">
                        <div className="gift-title-badge">
                            <img src={GiftTopSvg} alt="" />
                            <span className="badge-text">Подарок</span>
                        </div>
                        <div className="gift-inputs">
                            <div className="gift-input-group">
                                <label>Название подарка:</label>
                                <input
                                    type="text"
                                    value={gift.name || ''}
                                    onChange={(e) => handleGiftChange(index, 'name', e.target.value)}
                                    placeholder="Введите название подарка"
                                />
                            </div>
                            <div className="gift-input-group">
                                <label>Описание:</label>
                                <textarea
                                    value={gift.description || ''}
                                    onChange={(e) => handleGiftChange(index, 'description', e.target.value)}
                                    placeholder="Введите описание подарка"
                                    rows="3"
                                />
                            </div>
                        </div>
                        <button className="remove-gift-btn" onClick={() => removeGift(index)}>
                            Удалить
                        </button>
                    </div>
                ))}
            </div>

            <div className="admin-actions">
                <button className="add-gift-btn" onClick={addGift}>
                    <span>Добавить подарок</span>
                </button>
                <button className="save-gifts-btn" onClick={saveGifts} disabled={isSaving}>
                    <span>{isSaving ? 'Сохранение...' : 'Сохранить подарки'}</span>
                </button>
            </div>
        </div>
    );
};

export default GiftAdmin; 